var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z",
    fill: "#EF5350"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9974 1.16797C13.7716 1.16797 11.1641 3.77547 11.1641 7.0013C11.1641 10.2271 13.7716 12.8346 16.9974 12.8346C20.2232 12.8346 22.8307 10.2271 22.8307 7.0013C22.8307 3.77547 20.2232 1.16797 16.9974 1.16797ZM19.9141 9.09547L19.0916 9.91797L16.9974 7.8238L14.9032 9.91797L14.0807 9.09547L16.1749 7.0013L14.0807 4.90714L14.9032 4.08464L16.9974 6.1788L19.0916 4.08464L19.9141 4.90714L17.8199 7.0013L19.9141 9.09547Z",
    fill: "#EF5350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterError);
export default __webpack_public_path__ + "static/media/letter_error.13473941d6fe2c9adb3dad306c43c06f.svg";
export { ForwardRef as ReactComponent };